export enum IVerificationSourceEnum {
  EXPEDIA = "EXPEDIA",
  HOTELSCOM = "HOTELSCOM",
  VRBO = "VRBO",
  UNKNOWN = "UNKNOWN",
}

export enum IVerificationSourceRawTextEnum {
  EXPEDIA = "expedia group verified review",
  HOTELSCOM = "hotels.com verified review",
  VRBO = "vrbo verified review",
}

export const getVerificationSource = (
  source: string
): IVerificationSourceEnum => {
  switch (source.toLowerCase()) {
    case IVerificationSourceRawTextEnum.EXPEDIA:
      return IVerificationSourceEnum.EXPEDIA;
    case IVerificationSourceRawTextEnum.HOTELSCOM:
      return IVerificationSourceEnum.HOTELSCOM;
    case IVerificationSourceRawTextEnum.VRBO:
      return IVerificationSourceEnum.VRBO;
    default:
      return IVerificationSourceEnum.UNKNOWN;
  }
};

export const normalizeReviewScore = (score: number) => {
  return score * 10;
};

export const normalizeOverallScore = (score: number) => {
  return score / 10;
};

export const formatScore = (score: number, locale: string): string => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(score);
};

export const formatReviewDate = (date: string) => {
  const cleaned = date.replace(/\[.*?\]$/, "");

  const newDate = new Date(cleaned);

  if (Number.isNaN(newDate.getTime())) return null;

  return newDate;
};
